module.exports = __webpack_public_path__ + "static/media/5H.d64b8d5b.svg";